import { render, staticRenderFns } from "./InstallationUpdatesStatusCard.vue?vue&type=template&id=7d536f82&"
import script from "./InstallationUpdatesStatusCard.vue?vue&type=script&lang=ts&"
export * from "./InstallationUpdatesStatusCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports